import React, { Component } from "react";
import { connect } from "react-redux";

class ClientOrder extends Component {

    componentDidMount() {
    }

  render() {
    const { ServiceTypes, userData } = this.props;

    return (
      <div className="client-info-wrapper">

        <header className="client-header">
          <h2 className="header-title">بيانات الطلب</h2>
        </header>

        <div className="info-grid">
          <div className="info-grid-cell"> 
            <p className="info-cell-p">نوع الخدمة المقدمة</p>
            <h6 className="info-cell-val">{ServiceTypes?.find(ele => ele.Id === userData?.ServiceTypeId)?.NameLT}</h6>
          </div>
          <div className="info-grid-cell">
            <p className="info-cell-p">السعي</p>
            <h6 className="info-cell-val">{userData?.Profit}{userData?.IsRatio&&"%"}</h6>
          </div>
        </div>

      </div>
    ); 
  }
}

const mapStateToProps = (state) => ({
  ServiceTypes : state.user.metaData.ServiceTypes,
  userRequest : state.user.userRequest,
}) 

export default connect(mapStateToProps)(ClientOrder); 